<template>
  <!-- Projects -->
  <div class="projects">
    <div class="container objective">
      <div class="row">
        <div class="col-12 text-center center">
          <h2>Our Projects</h2>
        </div>
      </div>
      <div class="row" v-if="projects">
        <div v-for="project in projects" class="col-10 offset-1 col-md-6 offset-md-0 col-lg-4 mb-3 text-center center" v-bind:key="project">
          <router-link :to="`/project/${project.id}`">
            <div class="revive-card">
              <div class="label"> {{ project.projectStatus === 'inProgress' ? "In Progress" : "Delivered" }} </div>
              <div v-if="project.image.url" class="card-img-top"
                :style="{ background: `linear-gradient(to bottom, rgba(0, 0, 0, 0) 85%, rgba(0, 83, 1, 1) 100%), url(${project.image.url})` }"> </div>
              <div class="card-body">
                <h5 class="card-title">{{ project.name }}</h5>
                <p class="card-text">{{ project.description }}</p>
              </div> 
            </div> 
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useProjectsStore } from '@/stores/projects'
import { defineProps, computed } from 'vue'

const props = defineProps(['maxProjects'])

const store = useProjectsStore()
store.init();
const projects = computed(() => props.maxProjects ? store.projects.value.slice(0, props.maxProjects) : store.projects.value);
</script>
<style lang="scss" scoped>
  .projects {
    padding: 2rem 0;

    h2 {
      padding: 2rem;
      color: white;
    }
  }
  
  a {
    text-decoration: none;
    height: 100%;
    display: flex;
  }
</style>